import PropTypes from 'prop-types'

import Thumbnail from './Thumbnail.js'

const GalleryBasicThumbnails = ({images, onClickThumbnail, selectedSlide}) => {
  const firstImage = images.find(image => image.isVideo !== true)
  return images.map((image, index) => {
    const isSelected = selectedSlide === index

    const handleClickThumbnail = () => onClickThumbnail({selectedSlide: index})

    return (
      <Thumbnail
        firstImage={firstImage}
        image={image}
        isSelected={isSelected}
        key={index}
        onClickThumbnail={handleClickThumbnail}
      />
    )
  })
}

GalleryBasicThumbnails.displayName = 'GalleryBasicThumbnails'
GalleryBasicThumbnails.propTypes = {
  forceImageCrop: PropTypes.bool,
  images: PropTypes.arrayOf(
    PropTypes.shape({
      alt: PropTypes.string,
      src: PropTypes.string.isRequired,
      title: PropTypes.string
    })
  ).isRequired,
  onClickThumbnail: PropTypes.func.isRequired,
  selectedSlide: PropTypes.number
}

export default GalleryBasicThumbnails
